import type { SuggestionKeyDownProps, SuggestionProps } from '@tiptap/suggestion';

import type { EditorPluginConfig, ViewerPluginConfig } from './../ricos-types';

export const MENTION_TYPE = 'mention';

export interface MentionsPluginEditorConfig extends EditorPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  zIndex?: number;
}
export interface MentionsPluginViewerConfig extends ViewerPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export type Mention = {
  name: string;
  slug: string;
  id?: string;
  avatar?: string;
};

export type MentionListRef = {
  onKeyDown?: (props: SuggestionKeyDownProps) => boolean;
};

export type MentionSettings = {
  mentionPrefix?: string;
  mentionTrigger?: string;
  getMentionLink: () => string;
  repositionSuggestions: boolean;
  entryHeight: number;
  additionalHeight: number;
  visibleItemsBeforeOverflow: number;
  popoverComponent: React.ReactNode;
  onMentionClick?: (mention: Mention) => void;
  getMentions: (searchQuery: string) => Promise<Mention[]>;
  zIndex: number;
};

export interface MentionListProps extends SuggestionProps<Mention> {}
